<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('editCommandeTlpe.infoGenerales.annee')">
          <b-input :value="commandeTlpe.anneeDeclaration" disabled>
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('editCommandeTlpe.infoGenerales.typeDeclaration')">
          <b-input :value="$t(getLibelleTypeDeclaration)" disabled>
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <user-selector
          v-model="commandeTlpe.commercialId"
          :label="$t('editCommandeTlpe.infoGenerales.declarant')"
        />
      </div>
      <div class="column is-3">
        <b-field :label="$t('editCommandeTlpe.infoGenerales.referenceClient')">
          <b-input v-model="commandeTlpe.referenceClient">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('editCommandeTlpe.infoGenerales.codeDossier')">
          <b-input v-model="commandeTlpe.codeDossier">
          </b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { LISTE_TYPE_DECLARATION } from '@/configuration/gabed/tlpe/tlpeConf';
import userSelector from '@/components/commun/user/userSelector';

export default {
  props: {
    commandeTlpe: {
      type: Object,
      required: true,
    },
  },
  components: {
    userSelector,
  },
  computed: {
    getLibelleTypeDeclaration() {
      const typeDeclarationFind = LISTE_TYPE_DECLARATION.find((t) => {
        return t.code === this.commandeTlpe.typeDeclaration;
      });
      return typeDeclarationFind ? typeDeclarationFind.libelle : '';
    },
  },
};

</script>
